:host {
  display: block;
}
.vs-zindexminus {
  z-index: -1;
}
.vs-zindexplus {
  z-index: 1;
}
.vs-rounded-image {
  border-radius: 30px;
}
.vs-1-1 {
  aspect-ratio: 1/1;
}
.vs-16-9 {
  aspect-ratio: 16/9;
}
.vs-featured-faded {
  opacity: 0;
  transform: opacity 0.5s;
}
.vs-pb-20 {
  padding-bottom: 20px;
}
.vs-pb-10 {
  padding-bottom: 10px;
}
.vs-featured-container .vs-featured-bc {
  font-size: 17px;
}

.vs-featured-container .vs-link-cta {
  font-size: 17px;
}

.vs-featured-container .richtext .vs-featured-bc h2,
.vs-featured-container .richtext .vs-featured-bc h3,
.vs-featured-container .richtext .vs-featured-bc h4 {
  font-size: 17px;
}
.vs-featured-container {
  transition: background-color 1s;
}
.vs-featured-container img,
.vs-featured-container video {
  width: 100% !important;
  height: auto !important;
}
.vs-featured-container.vs-featured-text-right {
  display: flex;
}

.vs-featured-container .vs-featured-screen {
  transition: opacity 1s ease;
  position: relative;
  padding: 40px;
}

.vs-featured-container.vs-featured-desktop .vs-featured-screen {
  position: absolute;
  top: 50%
}



.vs-featured-container.vs-featured-text-left .vs-featured-screen {
  display: flex;
  align-items: center;
  width: fit-content;
  justify-content: flex-end;
}


.vs-featured-desktop .vs-fc-s-wrapper {
  overflow: hidden;
}
.vs-featured-desktop .vs-fc-s-wrapper {
  display: none !important;
}

.vs-featured-container .vs-featured-media {
  left: max(50%, 600px);
  top: 0;
  display: none;
  position: sticky;
  height: 100vh;
  max-width: max(50vw, 600px);
  overflow: hidden;
  align-items: center;
  justify-content: flex-start;
  z-index: 2;
  width: 50%;
}

.vs-featured-container.vs-featured-text-right.vs-featured-desktop .vs-featured-media {
  display: flex;
  left: 0;
  margin-left: auto;
}
.vs-featured-container.vs-featured-text-left.vs-featured-desktop .vs-featured-media {
  display: flex;
}
.vs-featured-container .vs-featured-sections {
  position: relative;
  width: -webkit-fill-available;
}
.vs-featured-container.vs-featured-desktop .vs-featured-sections {
  width: 50%;
}
.vs-featured-container.vs-featured-desktop.vs-featured-text-left .vs-featured-sections {
  margin-top: -100vh;
}

.vs-featured-container .vs-video-wrapper {
  display: flex;
  position: absolute;
  width: 100%;
  transition: opacity 1s ease !important;
  transform: translateY(-50%);
  align-items: center;
  height: -webkit-fill-available;
  width: -webkit-fill-available;
}
.vs-featured-container.vs-featured-text-right .vs-video-wrapper {
  justify-content: flex-end;
}

.vs-featured-container .vs-featured-section {
  display: flex;
  align-items: center;
  position: relative;
}
.vs-featured-container.vs-featured-desktop .vs-featured-section {
  min-height: 100vh;
}

.vs-featured-container .vs-featured-section.mobile .vs-fc-section-content {
  display: flex !important;
  flex-direction: column !important;
}

.vs-featured-container.vs-featured-desktop .vs-featured-section {
  padding-left: 30px;
  padding-right: 30px;
  overflow-x: hidden;
}

.vs-featured-container .vs-fc-section-content {
  display: flex;
  align-items: center;
  position: relative;
  min-height: 300px;
}
.vs-featured-container.vs-featured-text-left .vs-fc-section-content {
  margin-left: auto;
}
.vs-featured-container.vs-featured-text-right .vs-fc-section-content {
  margin-right: auto;
}


.vs-featured-container.vs-featured-mobile .vs-featured-section .vs-fc-section-content {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: static;
  flex-direction: column-reverse;
  margin-left: auto;
  margin-right: auto;
  padding: 30px;
}
.vs-featured-container.vs-featured-tablet .vs-fc-section-content {
  display: flex;
  align-items: center;
  padding: initial;
  width: 100%;
  position: initial;
  justify-content: flex-start;
  margin-left: auto;
  margin-right: auto;
}
.vs-featured-container .vs-featured-section.mobile .vs-fc-s-wrapper {
  order: -1; /* Move the image to the top */
}

.vs-featured-container .vs-fc-text-wrapper {
  position: relative;
  height: 100vh;
  align-items: flex-start;
  justify-content: center;
  display: flex;
  flex-direction: column;
  max-width: 552px;
  margin-left: auto;
  letter-spacing: 0.005em;
  font-family: 'visa-font-latin-light', 'visa-font-greek-light', 'visa-font-cyrillic-light';
  width: 100%;
}
.vs-featured-container.vs-featured-desktop .vs-fc-text-wrapper {
  min-width: 300px;
}
.vs-featured-container.vs-featured-mobile .vs-fc-text-wrapper {
  height: fit-content;
  padding: unset;
  width: 100%;
  margin-top: 20px;
  margin: initial;
  padding-top: 20px;
}
.vs-featured-container.vs-featured-tablet .vs-fc-text-wrapper {
  margin: 0px;
  width: 50%;
  height: fit-content;
}


.vs-featured-container.vs-featured-tablet.vs-featured-text-left .vs-fc-text-wrapper {
  margin-right: 30px;
  margin-left: auto;
}

.vs-featured-container.vs-featured-tablet.vs-featured-text-right .vs-fc-text-wrapper {
  margin-left: 30px;
  margin-right: auto;

}

.vs-featured-text-right.vs-featured-desktop .vs-fc-text-wrapper {
  margin: initial;
  right: initial;
}

.vs-featured-container.vs-featured-text-left .vs-fc-text-wrapper {
  margin-right: initial;
}

.vs-featured-tablet.vs-featured-text-right .vs-fc-text-wrapper {
  order: 2;
}

.vs-featured-container .vs-fc-s-wrapper {
  top: unset;
  max-width: 100%;
  left: max(50%, 600px);
  left: 50%;
  margin-top: -4px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vs-featured-container.vs-featured-mobile .vs-fc-s-wrapper {
  display: flex;
  justify-content: unset;
  margin-top: 20px;
  position: relative;
  left: 0px;
  width: 100%;
  top: unset;
}


.vs-featured-container.vs-featured-mobile .room-screen-content {
  position: relative;
}

.vs-featured-container.vs-featured-tablet .vs-fc-s-wrapper {
  padding: 40px;
  position: initial;
}

.vs-featured-container.vs-featured-tablet.vs-featured-text-left .vs-fc-s-wrapper {
  margin-left: 0px;
  margin-right: auto;
}

.vs-featured-container.vs-featured-tablet.vs-featured-text-right .vs-fc-s-wrapper {
  margin-left: auto;
  margin-right: 0px;
}
/* //Desktop plus up */
@media (min-width: 1200px) {
  .vs-fc-s-wrapper.vs-16-9,
  .vs-featured-screen.vs-16-9 {
    min-width: 552px;
    max-width: 900px;
  }
  .vs-fc-s-wrapper.vs-1-1,
  .vs-featured-screen.vs-1-1 {
    min-height: 552px;
    max-height: 800px;
  }
}
/* Editorial Template CSS is impecting featured component, Hence overriding when there's featured component on editorial page
*/
.vs-editorial-details-template {
  overflow: unset !important;
  padding-bottom: 0.1px;
}
/*
  When using richtext class vs-alt's color is different
*/
div.richtext .vs-alt p {
  color: #fff;
}

/*
  Overriding vs-display-1 line-height as per the design discussion
*/
.vs-featured-container .vs-display-1, .vs-featured-container .vs-fc-text-wrapper .vs-lead {
  margin-bottom: 20px;
}
.vs-featured-container .vs-display-2 {
  margin-bottom: 20px;
}

@media (min-width: 1200px) {
  .vs-featured-container .vs-display-1 {
      font-size: 65px;
      line-height: 70px;
  }
  .vs-featured-container .vs-display-2 {
    font-size: 52px;
    line-height: 56px;
 }
  .vs-featured-container .vs-display-3 {
    font-size: 42px;
    line-height: 48px;
  }
  .vs-featured-container .vs-featured-bc {
    font-size: 17px;
  }
  .vs-featured-container .richtext .vs-featured-bc h2,
  .vs-featured-container .richtext .vs-featured-bc h3,
  .vs-featured-container .richtext .vs-featured-bc h4 {
    font-size: 17px;
  }
  .vs-featured-container .vs-link-cta {
    font-size: 17px;
  }
}
@media (min-width: 768px) and (max-width: 1199px) {
  .vs-featured-container.vs-featured-tablet .vs-fc-section-content {
    padding: 30px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .vs-featured-container .vs-display-2 {
    font-size: 36px !important;
  }
  .vs-featured-container .vs-display-3 {
    font-size: 30px !important;
    line-height: 35px !important;
  }
  .vs-featured-container .vs-display-1{
    font-size: 40px !important;
    line-height: 46px !important;
  }
}

@media (max-width: 991px) {
  .vs-featured-container .vs-display-2 {
    font-size: 28px !important;
  }
  .vs-featured-container .vs-display-3 {
    font-size: 24px !important;
    line-height: 28px !important;
  }
  .vs-featured-container .vs-display-1{
    font-size: 34px !important;
    line-height: 38px !important;
  }
}
.vs-featured-h30 {
  height: 30px;
}

.vs-featured-container .vs-full-width {
  width: 100%;
}

.vs-featured-container .vs-fc-s-wrapper-tablet{
  width: 50%;
}
